/**
 * The Log internal time dialog: InternalTimeForm in the house Dialog, with
 * Cancel (Close on a locked period) and Log time. One dialog behind two
 * doors (LP-43): My time's "Log internal time" and My Clients'
 * "+ Internal Time". The form, its submit and its copy are
 * InternalTimeForm's; a save closes the dialog, and the create hook
 * refreshes My time's totals and the period's entries wherever they are
 * read.
 */

import type { ReactNode } from 'react';
import { Dialog } from '@/components/primitives/Dialog';
import { InternalTimeForm, type InternalTimeCardProps } from '@/components/time/InternalTimeCard';

export interface LogInternalTimeDialogProps extends InternalTimeCardProps {
  onClose: () => void;
  /** Runs after a save lands, before the dialog closes. */
  onSaved?: () => void;
}

export function LogInternalTimeDialog({
  tenantSlug,
  period,
  configPresent,
  hoursIncrement,
  todayIso,
  hoursInputRef,
  onClose,
  onSaved,
}: LogInternalTimeDialogProps): ReactNode {
  return (
    <Dialog title="Log internal time" size="md" testId="log-internal-time-dialog" onClose={onClose}>
      <div className="mt-3">
        <InternalTimeForm
          tenantSlug={tenantSlug}
          period={period}
          configPresent={configPresent}
          hoursIncrement={hoursIncrement}
          todayIso={todayIso}
          hoursInputRef={hoursInputRef}
          onSaved={() => {
            onSaved?.();
            onClose();
          }}
          onCancel={onClose}
        />
      </div>
    </Dialog>
  );
}
